import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  PERSONALIZATION_DEFAULT_CONFIG,
  RENDER_MODES,
} from '../../../shared/constants';
import { usePersonalization } from '../../../shared/hooks';
import { type RenderModeState } from '../data-layer/violationsTabTypes';
import { violationsTabActions } from '../data-store/violationsTabSlice';

const useSetRenderMode = ({
  type,
  currentMode,
}: {
  type?: string;
  currentMode?: RenderModeState;
}) => {
  const dispatch = useDispatch();
  const { getPersonlization } = usePersonalization();

  const defaultMode = useMemo(() => {
    if (type === 'entitlement') {
      return RENDER_MODES.LIST;
    }

    const personalization = getPersonlization();

    return PERSONALIZATION_DEFAULT_CONFIG.saveMode &&
      personalization &&
      personalization.mode
      ? personalization.mode
      : currentMode ?? RENDER_MODES.GRAPH;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should not depend upon `currentMode`
  }, [getPersonlization, type]);

  useEffect(() => {
    dispatch(violationsTabActions.setRenderMode(defaultMode));
  }, [dispatch, defaultMode]);
};

// eslint-disable-next-line import/prefer-default-export
export { useSetRenderMode };
